<template>
    <v-main style="height: 100%; padding: 0; margin: 0">
            <div style="width: 50%; height: 35%; float: left; background: #FFF; ">
            <div style="text-align:center; padding-top: 2%"><h2 v-if="contextSelected==0">Experience Summary</h2><h2 v-else>Module Completion Rates</h2></div>
            <div style="text-align:center; margin: auto; width: 50%;" v-if="contextSelected==0">
                <v-select v-model=selected.experience :items="expOption" v-on:change="experienceOptionChanged" item-text="text" item-value="value" label="Selection..." persistent-hint></v-select>
            </div>
            <Doughnut
                v-if="experienceData.labels.length > 0"
                id="my-doughnutchart-id"
                :chart-options="chartDoughnutOptions"
                :chart-data="experienceData"
                :height="adminExperienceId == undefined ? 250 : 200"
                style="padding-top: 0; padding-right: 20%;"
            />
            <div v-else style="text-align:center; margin: auto; width: 50%; padding-bottom:150px; padding-top:150px">
                <h3>No data</h3>
            </div>
        </div>

            <div style="width: 50%; height: 35%; float: left; background: #FFF; ">
            <div style="text-align:center; padding-top: 2%;"><h2 v-if="contextSelected==0">Booth Summary</h2><h2 v-else>Time Tracking</h2></div>
            <div style="text-align:center; margin: auto; width: 50%;" v-if="contextSelected==0">
                <v-select v-model=selected.booth :items="boothOption" v-on:change="boothOptionChanged" item-text="text" item-value="value" label="Selection..." persistent-hint></v-select>
            </div>
            <Bar
                v-if="boothData.labels.length > 0"
                id="my-barchart-id"
                :chart-options="chartBarOptions"
                :chart-data="boothData"
                height="100"
                style="padding-left: 3%; padding-right: 3%; padding-top: 0;"
                />
            <div v-else style="text-align:center; margin: auto; width: 50%; padding-bottom:150px; padding-top:150px">
                <h3>No data</h3>
            </div>    
        </div>

            <div style="width: 50%; padding-top: 2%; height: 35%; float: left; background: #FFF; " v-if="contextSelected==0">
            <div style="text-align:center; padding-top: 2%;"><h2>Video Summary</h2></div>
            <div style="text-align:center; margin: auto; width: 50%;">
                <v-select v-model=selected.video :items="videoOption" v-on:change="videoOptionChanged" item-text="text" item-value="value" label="Selection..." persistent-hint></v-select>
            </div>
            <LineChartGenerator
                v-if="videoData.labels.length > 0"
                id="my-linechart-id"
                :chart-options="chartLineOptions"
                :chart-data="videoData"
                height="200"
                style="padding-left: 3%; padding-right: 3%;"
            />
            <div v-else style="text-align:center; margin: auto; width: 50%; padding-bottom:150px; padding-top:150px">
                <h3>No data</h3>
            </div>
        </div>

            <div style="width: 50%; padding-top: 2%; height: 35%; float: left; background: #FFF; " v-if="contextSelected==0">
            <div style="text-align:center; padding-top: 0;"><h2>Chat Summary</h2></div>
            <Bar
                v-if="chatData.labels.length > 0"
                id="my-barchart-id"
                :chart-options="chartBarOptions"
                :chart-data="chatData"
                height="100"
                style="padding-left: 3%; padding-right: 3%; padding-top: 0;"
                />
            <div v-else style="text-align:center; margin: auto; width: 50%; padding-bottom:150px; padding-top:150px">
                <h3>No data</h3>
            </div>
            </div>
        
    </v-main>
  
</template>

<script>
import axios from "axios";
import { Bar, Doughnut, Line as LineChartGenerator } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, ArcElement, LineElement, PointElement, CategoryScale, LinearScale, Filler } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, ArcElement, LineElement, PointElement, CategoryScale, LinearScale, Filler)

export default {
    props: ['option', 'guid', 'adminExperienceId', 'businessnameId'],
    name: 'Chart',
    components: { Bar, Doughnut, LineChartGenerator },
    data() {
        return {
            trainingURL: this.$vtrainingurl + "/api/v1/front-end/",
            contextSelected : 0,
            selected : {
                experience: 0,
                booth: 0,
                video: 0
            },
            expOption: [
                { text : "Overall Stat Summary of Attendees", value : 0},
                { text : "User Login Report", value : 1},
                { text : "User Added Item To Briefcase", value : 2},
                { text : "User Removed Item From Briefcase", value : 3},
                { text : "User Leaderboard", value : 4},
            ],
            boothOption: [
                { text : "Number Of Booth Visitor", value : 0},
                { text : "Overall Booth Summary", value : 1},
                { text : "Booth Document And Video Viewed", value : 2},
                { text : "Booth Banner Clicked", value : 3},
                { text : "Booth Content Links Clicked", value : 4},
            ],
            videoOption: [
                { text : "Presentation Video Viewed", value : 0},
                { text : "Live Presentation Unique Viewed", value : 1},
                { text : "Room Banner Visited", value : 2},
            ],

            expKey: [],
            expValue: [],

            boothKey: [],
            boothValue: [],

            videoKey: [],
            videoValue: [],

            chatKey: [],
            chatValue: [],

            chatData: {
                labels: [],
                datasets: [{ 
                    data: [], 
                    backgroundColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderWidth: 2,
                    hoverOffset: 10
                }]
            },
            boothData: {
                labels: [],
                datasets: [{ 
                    data: [], 
                    backgroundColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98', '#18304D'],
                    borderWidth: 2,
                    hoverOffset: 10
                }]
            },
            experienceData: {
                labels: [],
                datasets: [{ 
                    data: [], 
                    backgroundColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98'],
                    borderColor: ['#6CE5E8', '#41B8D5', '#2D8BBA', '#2F5F98'],
                    borderWidth: 2,
                    hoverOffset: 0
                }]
            },
            videoData: {
                labels: [],
                datasets: [{ 
                    backgroundColor: '#6CE5E8',
                    borderColor: ['#6CE5E8'],
                    data: [], 
                    fill: true
                }]
            },
            chartDoughnutOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'right',
                        align: 'center',
                        labels : {
                            boxWidth : 15,
                            boxHeight : 15,
                            padding: 20,
                            font : {
                                size: 13
                            },
                            textAlign: 'center'

                        }
                    }
                }
            },
            chartBarOptions: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    x: {
                        ticks: {
                            precision: 0,
                            display: true,
                            font: {
                                size: 13
                            }
                        },
                        display: true,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        ticks: {
                            precision: 0,
                            display: true,
                            font: {
                                size: 13
                            }
                        },
                        grid: {
                            display: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            },
            chartLineOptions: {
                layout: {
                    padding: 0
                },
                elements: {
                    point: {
                        radius: 0,
                        borderWidth: 0
                    }
                },
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    x: {
                        ticks: {
                            precision: 0,
                            display: true,
                            font: {
                                size: 13
                            }
                        },
                        display: true,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        ticks: {
                            precision: 0,
                            display: true,
                            beginAtZero: true,
                            font: {
                                size: 13
                            }
                        },
                        suggestedMin: 0,
                        grid: {
                            display: true,
                        }
                    }
                },
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            },
           
        }
    },
    watch: {
        businessnameId:{
            immediate: true,
            handler() {
                this.getModuleCompletion();
                this.getTimeTracking();
            }
        },
        adminExperienceId: {
            immediate: true,
            handler() {
                this.expKey =  [];
                this.expValue = [];
                this.boothKey = [];
                this.boothValue = [];
                if (this.contextSelected == 0) {
                    switch(this.selected.experience) {
                        case 0 : this.getExperienceOverall();
                            break;
                        case 1 : this.getExperienceLogin();
                            break;
                        case 2 : this.getExperienceBriefcaseAdd();
                            break;
                        case 3 : this.getExperienceBriefcaseRemove();
                            break;
                        case 4 : this.getExperienceLeaderboard();
                            break;
                    }
                    switch(this.selected.booth) {
                        case 0 : this.getBoothVisitorList();
                            break;
                        case 1 : this.getBoothSummary();
                            break;
                        case 2 : this.getBoothDocumentVideoSummary();
                            break;
                        case 3 : this.getBoothBannerClicked();
                            break;
                        case 4 : this.getBoothContentLinks();
                            break;
                    }
                    switch(this.selected.video) {
                        case 0 : this.getVideoSummary();
                            break;
                        case 1 : this.getLiveVideoSummary();
                            break;
                        case 2 : this.getRoomBanner();
                            break;
                    }

                    this.getChatSummary();
                } 
                // else {
                //     this.getModuleCompletion();
                //     this.getTimeTracking();
                // }
            }
        },
        option: {
            immediate: true,
            handler(val) {
                this.contextSelected = val
                this.expKey =  [];
                this.expValue = [];
                this.boothKey = [];
                this.boothValue = [];
                if (this.contextSelected == 0) {
                    switch(this.selected.experience) {
                        case 0 : this.getExperienceOverall();
                            break;
                        case 1 : this.getExperienceLogin();
                            break;
                        case 2 : this.getExperienceBriefcaseAdd();
                            break;
                        case 3 : this.getExperienceBriefcaseRemove();
                            break;
                        case 4 : this.getExperienceLeaderboard();
                            break;
                    }
                    switch(this.selected.booth) {
                        case 0 : this.getBoothVisitorList();
                            break;
                        case 1 : this.getBoothSummary();
                            break;
                        case 2 : this.getBoothDocumentVideoSummary();
                            break;
                        case 3 : this.getBoothBannerClicked();
                            break;
                        case 4 : this.getBoothContentLinks();
                            break;
                    }
                    switch(this.selected.video) {
                        case 0 : this.getVideoSummary();
                            break;
                        case 1 : this.getLiveVideoSummary();
                            break;
                        case 2 : this.getRoomBanner();
                            break;
                    }

                    this.getChatSummary();
                } else {
                    this.getModuleCompletion();
                    this.getTimeTracking();
                } 
            }
        }
    },
    mounted() {
        this.getExperienceOverall();
        this.getBoothVisitorList();
        this.getVideoSummary();
        this.getChatSummary();

        this.getModuleCompletion();
        this.getTimeTracking();
    },
    methods: {
        getModuleCompletion() {
            axios.post("/system/chartdata/module-completion",  
                {guid: this.guid, businessnameId: this.businessnameId === "All" ? 0 : this.businessnameId })
            .then(response => {
                
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.expKey.push(response.data[i].MODULE_NAME.substring(0, 30) + (response.data[i].MODULE_NAME.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].COMPLETED);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;
            })
            .catch(() => {});
        },
        getTimeTracking() {
            axios.post("/system/chartdata/time-tracking",  
                {guid: this.guid, businessnameId: this.businessnameId === "All" ? 0 : this.businessnameId})
            .then(response => {

                this.boothKey = [];
                this.boothValue = [];

                for (let i=0; i < response.data.length; i++) {
                        this.boothKey.push(response.data[i].MODULE_NAME.substring(0, 30) + (response.data[i].MODULE_NAME.length > 20? "..." : ""));
                        this.boothValue.push(parseInt(response.data[i].time_in_module_sec));
                    }

                    this.boothData.labels = this.boothKey;
                    this.boothData.datasets[0].data = this.boothValue;

            })
            .catch(() => {});
        },

        experienceOptionChanged(e) {
            switch(e) {
                case 0 : this.getExperienceOverall();
                    break;
                case 1 : this.getExperienceLogin();
                    break;
                case 2 : this.getExperienceBriefcaseAdd();
                    break;
                case 3 : this.getExperienceBriefcaseRemove();
                    break;
                case 4 : this.getExperienceLeaderboard();
                    break;
            }
        },
        boothOptionChanged(e) {
            switch(e) {
                case 0 : this.getBoothVisitorList();
                    break;
                case 1 : this.getBoothSummary();
                    break;
                case 2 : this.getBoothDocumentVideoSummary();
                    break;
                case 3 : this.getBoothBannerClicked();
                    break;
                case 4 : this.getBoothContentLinks();
                    break;
            }
        },
        videoOptionChanged(e) {
            switch(e) {
                case 0 : this.getVideoSummary();
                    break;
                case 1 : this.getLiveVideoSummary();
                    break;
                case 2 : this.getRoomBanner();
                    break;
            }
        },

        getRoomBanner() {
            axios.post("/system/chartdata/video/roombanner",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.videoKey = [];
                this.videoValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.videoKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.videoValue.push(response.data[i].total);
                }

                this.videoData.labels = this.videoKey;
                this.videoData.datasets[0].data = this.videoValue;

            })
            .catch(() => {});
        },

        getLiveVideoSummary() {
            axios.post("/system/chartdata/video/livepresentation",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.videoKey = [];
                this.videoValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.videoKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.videoValue.push(response.data[i].total);
                }

                this.videoData.labels = this.videoKey;
                this.videoData.datasets[0].data = this.videoValue;

            })
            .catch(() => {});
        },

        getBoothContentLinks() {
            axios.post("/system/chartdata/booth/content",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.boothKey = [];
                this.boothValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.boothKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.boothValue.push(response.data[i].total);
                }

                this.boothData.labels = this.boothKey;
                this.boothData.datasets[0].data = this.boothValue;

            })
            .catch(() => {});
        },
        getBoothBannerClicked() {
            axios.post("/system/chartdata/booth/banner",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.boothKey = [];
                this.boothValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.boothKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.boothValue.push(response.data[i].total);
                }

                this.boothData.labels = this.boothKey;
                this.boothData.datasets[0].data = this.boothValue;

            })
            .catch(() => {});
        },
        getBoothDocumentVideoSummary() {
            axios.post("/system/chartdata/booth/document",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.boothKey = [];
                this.boothValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.boothKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.boothValue.push(response.data[i].total);
                }

                this.boothData.labels = this.boothKey;
                this.boothData.datasets[0].data = this.boothValue;

            })
            .catch(() => {});
        },

        getBoothVisitorList() {
            axios.post("/system/chartdata/booth/visitor-list",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.boothKey = [];
                this.boothValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.boothKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.boothValue.push(response.data[i].total);
                }

                this.boothData.labels = this.boothKey;
                this.boothData.datasets[0].data = this.boothValue;

            })
            .catch(() => {});
        },

        getExperienceLeaderboard(){
            axios.post("/system/chartdata/experience/leaderboard",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                   
                    this.expKey.push(response.data[i].email.substring(0, 30) + (response.data[i].email.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].point);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;

            })
            .catch(() => {});
        },
        getExperienceBriefcaseRemove(){
            axios.post("/system/chartdata/experience/briefcase-removed",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.expKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].total);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;

            })
            .catch(() => {});
        },
        getExperienceBriefcaseAdd(){
            axios.post("/system/chartdata/experience/briefcase-added",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.expKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].total);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;

            })
            .catch(() => {});
        },

        getExperienceLogin(){
            axios.post("/system/chartdata/experience/login",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.expKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].total);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;

            })
            .catch(() => {});
        },

        getExperienceOverall(){
            axios.post("/system/chartdata/experience/overall",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.expKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].total);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;

            })
            .catch(() => {});
        },


        getExperienceSummary() {
            axios.post("/system/chartdata/experiencesummary",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.expKey = [];
                this.expValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.expKey.push(response.data[i].email.substring(0, 30) + (response.data[i].email.length > 20? "..." : ""));
                    this.expValue.push(response.data[i].point);
                }

                this.experienceData.labels = this.expKey;
                this.experienceData.datasets[0].data = this.expValue;

            })
            .catch(() => {});
        },
        getBoothSummary() {
            axios.post("/system/chartdata/boothsummary",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.boothKey = [];
                this.boothValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.boothKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.boothValue.push(response.data[i].total);
                }

                this.boothData.labels = this.boothKey;
                this.boothData.datasets[0].data = this.boothValue;

            })
            .catch(() => {});
        },
        getVideoSummary() {
            axios.post("/system/chartdata/video/summary",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.videoKey = [];
                this.videoValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.videoKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.videoValue.push(response.data[i].total);
                }

                this.videoData.labels = this.videoKey;
                this.videoData.datasets[0].data = this.videoValue;

            })
            .catch(() => {});
        },
        getChatSummary() {
            axios.post("/system/chartdata/chat/summary",  
                {experienceId: this.adminExperienceId == undefined ? this.$store.state.principal.experienceId : this.adminExperienceId})
            .then(response => {
                this.chatKey = [];
                this.chatValue = [];

                for (let i=0; i < response.data.length; i++) {
                    this.chatKey.push(response.data[i].name.substring(0, 20) + (response.data[i].name.length > 20? "..." : ""));
                    this.chatValue.push(response.data[i].total);
                }

                this.chatData.labels = this.chatKey;
                this.chatData.datasets[0].data = this.chatValue;

            })
            .catch(() => {});
        }
    }
}
</script>